var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanCardBulletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF9F43",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7319 10.2958C21.5442 10.1065 21.2886 10 21.0219 10C20.7553 10 20.4997 10.1065 20.3119 10.2958L12.8619 17.7558L9.73195 14.6158C9.46936 14.3621 9.09139 14.2678 8.74042 14.3684C8.38945 14.469 8.1188 14.7492 8.03042 15.1034C7.94204 15.4577 8.04936 15.8321 8.31195 16.0858L12.1519 19.9258C12.3397 20.1151 12.5953 20.2216 12.8619 20.2216C13.1286 20.2216 13.3842 20.1151 13.5719 19.9258L21.7319 11.7658C21.9372 11.5765 22.0539 11.31 22.0539 11.0308C22.0539 10.7516 21.9372 10.4851 21.7319 10.2958Z",
    fill: "#FF9F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanCardBulletIcon);
export default __webpack_public_path__ + "static/media/loanCardBulletIcon.9f29b9dc9ec42751936cce0ed64e637c.svg";
export { ForwardRef as ReactComponent };